export const API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_USER_SUMMARY_BY_CATEGORY_PATH_KEY =
  '/organizations/{organizationId}/credits/user/summary-by-category';
export const API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_USER_HISTORY_PATH_KEY =
  '/organizations/{organizationId}/credits/user/history';
export const API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_USER_PATH_KEY =
  '/organizations/{organizationId}/credits/user';
export const API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_PATH_KEY =
  '/organizations/{organizationId}/credits';
export const API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_CHECK_PATH_KEY =
  '/organizations/{organizationId}/credits/check';
export const API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_YEAR_YEAR_QUARTER_QUARTER_PATH_KEY =
  '/organizations/{organizationId}/credits/year/{year}/quarter/{quarter}';
export const API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_DEPARTMENTS_DEPARTMENTID_YEAR_YEAR_QUARTER_QUARTER_PATH_KEY =
  '/organizations/{organizationId}/credits/departments/{departmentId}/year/{year}/quarter/{quarter}';
export const API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_DEPARTMENTS_DEPARTMENTID_TEAMS_TEAMID_YEAR_YEAR_QUARTER_QUARTER_PATH_KEY =
  '/organizations/{organizationId}/credits/departments/{departmentId}/teams/{teamId}/year/{year}/quarter/{quarter}';
export const API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_QUARTER_PATH_KEY =
  '/organizations/{organizationId}/credits/quarter';
export const API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_QUARTER_DEPARTMENTS_DEPARTMENTID_PATH_KEY =
  '/organizations/{organizationId}/credits/quarter/departments/{departmentId}';
export const API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_QUARTER_DEPARTMENTS_DEPARTMENTID_TEAMS_TEAMID_PATH_KEY =
  '/organizations/{organizationId}/credits/quarter/departments/{departmentId}/teams/{teamId}';
export const API_JOB_CALCULATE_STATS_PATH_KEY = '/job/calculate-stats';
export const API_ORGANIZATIONS_ORGANIZATIONID_ROLLBACK_CREDITS_PATH_KEY =
  '/organizations/{organizationId}/rollback/credits';
